import startCase from 'lodash/startCase';

import { ResponsiveText, Link, Chevron } from '@farmersdog/corgi';

import { useRoutes } from '../../static-context';

import styles from './BreedsLinks.css';

export function BreedsLinks() {
  const routes = useRoutes();
  const breedRouteMatches = routes
    .map(route => Array.from(route.url.matchAll(/\/(?:breed)\/(.+)/gi)))
    .filter(matches => matches.length > 0)
    .sort(([[, slug1]], [[, slug2]]) => (slug1 < slug2 ? -1 : 1));

  return (
    <ul aria-label="Breed page links" className={styles.list}>
      {breedRouteMatches.map(([match]) => {
        const [route, breedSlug] = match;
        const breed = startCase(breedSlug);

        return (
          <ResponsiveText
            as="li"
            variant="body-1"
            className={styles.item}
            key={route}
          >
            <Link key={route} to={route} mode="dark" variant="secondary">
              {breed} <Chevron className={styles.chevron} />
            </Link>
          </ResponsiveText>
        );
      })}
    </ul>
  );
}
